module.exports = __webpack_public_path__ + "static/media/icon_add_kpi.35e0e5ac.svg";